import { render, staticRenderFns } from "./UploadProductDocs.vue?vue&type=template&id=0662f356&scoped=true"
import script from "./UploadProductDocs.vue?vue&type=script&lang=js"
export * from "./UploadProductDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662f356",
  null
  
)

export default component.exports